import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Row, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as Utils from "../../Util/util";
import DataTable from "../../Components/DataTable";
import RequestStatus from "../../Components/RequestStatus";
import { getContactUsInfo } from "../../Store/Actions/EnquiryActions";

const ContactUsDataTable = (props) => {
	const enquiryState = useSelector((state) => state.enquiry);

	const columns = [
		{
			dataField: "parentName",
			text: "Name",
			style: { textAlign: "center", paddingTop: "4px" },
			headerStyle: { textAlign: "center", paddingTop: "4px" },
		},
		{
			dataField: "email",
			text: "Email",
			style: { textAlign: "center", paddingTop: "4px" },
			headerStyle: { textAlign: "center", paddingTop: "4px" },
		},

		{
			dataField: "mobileNumber",
			text: "Mobile Number",
			headerStyle: { textAlign: "center" },
			style: { textAlign: "center" },
		},
		{
			dataField: "message",
			text: "Message",
			style: { textAlign: "center", paddingTop: "4px" },
			headerStyle: { textAlign: "center", paddingTop: "4px" },
		},
		{
			dataField: "createdAt",
			text: "Created Date",
			style: { textAlign: "center" },
			headerStyle: { textAlign: "center" },
			formatter: Utils.formatDateInTable,
		},
	];

	return (
		<div>
			<DataTable
				keyField="id"
				columns={columns}
				data={enquiryState.contactData ?? []}
				search={true}
				pagination={true}
				button={false}
				dialogButton={false}
				dialogAction={() => {}}
				buttonLabel=""
				className="transaction-table"
			/>
		</div>
	);
};

const ListContactUsEnquiries = () => {
	const [alertStatus, setAlertStatus] = useState(true);

	const stateObject = useSelector((state) => state.enquiry);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getContactUsInfo());
	}, [dispatch]);

	return (
		<>
			<Breadcrumb>
				<li className="breadcrumb-item">
					<Link to="/">Home</Link>
				</li>
				<Breadcrumb.Item active>Contact Us Enquiries</Breadcrumb.Item>
			</Breadcrumb>
			<Card>
				<Card.Body>
					<Row>
						<Col md={12}>
							<ContactUsDataTable />
						</Col>
					</Row>
					<div className="text-center mt-5">
						<RequestStatus
							stateObj={stateObject}
							alertStatus={alertStatus}
							setAlertStatus={setAlertStatus}
						/>
					</div>
				</Card.Body>
			</Card>
		</>
	);
};

export default ListContactUsEnquiries;
